import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6690caee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "vip-dialog-wrap"
};
const _hoisted_2 = {
  class: "vip-dialog-header flex-items-center flex-row-space-between"
};
const _hoisted_3 = {
  class: "vip-dialog-title"
};
const _hoisted_4 = {
  class: "vip-dialog-content"
};
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = {
  class: "vip-title"
};
const _hoisted_7 = {
  class: "token-select"
};
const _hoisted_8 = {
  key: 0,
  class: "error-tip"
};
const _hoisted_9 = {
  class: "max-quota-tip"
};
const _hoisted_10 = {
  class: "vip-title"
};
const _hoisted_11 = {
  key: 2,
  class: "error-tip"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "vip-title"
}, " ID ", -1));
const _hoisted_13 = {
  key: 3,
  class: "error-tip"
};
const _hoisted_14 = {
  class: "vip-dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_close = _resolveComponent("close");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_token_select = _resolveComponent("token-select");
  const _component_sfe_input = _resolveComponent("sfe-input");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_vip_success = _resolveComponent("vip-success");
  const _directive_precision = _resolveDirective("precision");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    "model-value": $props.visible,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    center: true,
    "show-close": true,
    title: $setup.t('vipLoan1'),
    class: "vip-el-dialog",
    width: "480px",
    top: "8vh",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", _hoisted_3, _toDisplayString($setup.t('vipLoan1')), 1), _createVNode(_component_el_icon, {
      class: _normalizeClass(["close-icon ts vip-tip-close", {
        'disabled': _ctx.loading
      }]),
      onClick: _ctx.handleDialogCancel
    }, {
      default: _withCtx(() => [_createVNode(_component_close)]),
      _: 1
    }, 8, ["class", "onClick"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString($setup.t('chooseVipCryptoLoans')), 1), _createElementVNode("div", {
      class: "vip-content-link",
      onClick: _cache[0] || (_cache[0] = $event => $setup.toVipProgram(true))
    }, _toDisplayString($setup.t('vipThresholdRights')), 1), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString($setup.t('loanAmount')) + " ", 1), !$setup.isSub && $setup.isVIP || $setup.userInfo.appliedVipQuota ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "my-amount",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleClickMyLimit && _ctx.handleClickMyLimit(...args))
    }, _toDisplayString($setup.t('myLimit')), 1)) : _createCommentVNode("", true)]), _withDirectives((_openBlock(), _createBlock(_component_sfe_input, {
      modelValue: _ctx.amount,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.amount = $event),
      id: "loan-input-amount",
      placeholder: `${$setup.t('maxBorrowingLimit')}: ${$setup.toFormat(_ctx.maxLoanQuota)}`,
      "data-precision": "0",
      onInput: _ctx.handleAmountInput,
      class: _normalizeClass(["vip-content", {
        'error': _ctx.amountErrorTip
      }]),
      onOnBlur: _ctx.handleAmountBlur
    }, {
      append: _withCtx(() => [_createElementVNode("a", {
        class: "max-quota",
        onClick: _cache[2] || (_cache[2] = (...args) => _ctx.setMaxLoanQuota && _ctx.setMaxLoanQuota(...args))
      }, " Max "), _createElementVNode("div", _hoisted_7, [_createVNode(_component_token_select, {
        token: _ctx.loanToken || $props.token,
        data: $props.data,
        onChange: _ctx.changeLoanToken
      }, null, 8, ["token", "data", "onChange"])])]),
      _: 1
    }, 8, ["modelValue", "placeholder", "onInput", "class", "onOnBlur"])), [[_directive_precision]]), _ctx.amountErrorTip ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.amountErrorTip), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, _toDisplayString(`${$setup.t('maxBorrowingLimit')}`) + ": " + _toDisplayString($setup.toFormat(_ctx.maxLoanQuota)) + " " + _toDisplayString(_ctx.loanToken || $props.token), 1), _createElementVNode("div", _hoisted_10, _toDisplayString($setup.t('sns')), 1), _createVNode(_component_el_radio_group, {
      modelValue: _ctx.currentSocial,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.currentSocial = $event),
      class: "vip-content",
      onChange: _ctx.handleSnsTypeChange
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMediaList, item => {
        return _openBlock(), _createBlock(_component_el_radio, {
          label: item.id
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["label"]);
      }), 256))]),
      _: 1
    }, 8, ["modelValue", "onChange"]), _ctx.currentSocial == '99' ? (_openBlock(), _createBlock(_component_sfe_input, {
      key: 1,
      modelValue: _ctx.socialName,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.socialName = $event),
      id: "vip-input-social",
      onInput: _ctx.handleSnsNameInput,
      class: _normalizeClass(["vip-content", {
        'error': _ctx.snsNameErrorTip
      }]),
      maxlength: "50"
    }, null, 8, ["modelValue", "onInput", "class"])) : _createCommentVNode("", true), _ctx.snsNameErrorTip ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.t('variableCannotBeEmpty', {
      variable: $setup.t('sns')
    })), 1)) : _createCommentVNode("", true), _hoisted_12, _createVNode(_component_sfe_input, {
      modelValue: _ctx.accountId,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.accountId = $event),
      id: "vip-input-id",
      class: _normalizeClass(["vip-content", {
        'error': _ctx.accountErrorTip
      }]),
      onInput: _ctx.handleAccountIdInput,
      placeholder: $setup.t(_ctx.currentSocial === 20 || _ctx.currentSocial === 70 ? 'LoanAccountNumber' : 'LoanAccountID'),
      maxlength: "100"
    }, null, 8, ["modelValue", "onInput", "placeholder", "class"]), _ctx.accountErrorTip ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.accountErrorTip), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
      class: _normalizeClass(["flex-1 confirm", {
        'loading': _ctx.loading
      }]),
      type: "main",
      loading: _ctx.loading,
      onClick: _ctx.handleDialogConfirm
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('confirm')), 1)]),
      _: 1
    }, 8, ["class", "loading", "onClick"])])]),
    _: 1
  }, 8, ["model-value", "title"]), _createVNode(_component_vip_success, {
    visible: _ctx.successModal,
    onClose: _cache[7] || (_cache[7] = $event => _ctx.changeSuccessModal(false))
  }, null, 8, ["visible"])]);
}